<template>
  <div class="outer">

    <div class="form">
      <div class="input-box">
        <div class="label">收货人</div><input v-model="name" placeholder="请输入收货人姓名">
      </div>
      <div class="input-box">
        <div class="label">联系电话</div><input type="tel" v-model="phone" placeholder="请输入联系电话">
      </div>
      <div class="input-box">
        <div class="label">所在地区</div>
        <div class="select" @click="showAddrPicker(0)">{{ (selectedArea && selectedArea.join(' ')) || '请选择'}}</div>
      </div>
      <div class="input-box">
        <div class="label">街道</div>
        <div class="select" @click="showAddrPicker(1)">{{ (selectedStreet && selectedStreet.join(' ')) || '请选择'}}</div>
      </div>
      <div class="input-box textarea">
        <textarea v-model="addrDetail" placeholder="请填写详细地址，不少于5个字" />
      </div>
    </div>


    <div class="switch">
      <div class="label">设为默认地址</div>
      <div class="switch-wrapper">
<!--        <mt-switch size="larger" v-model="isDefaultAddr"></mt-switch>-->
        <van-switch v-model="isDefaultAddr" size=".5rem" active-color="#00d6d6" />
      </div>
    </div>

    <div class="btn" @click="save">保存</div>

    <!-- 选择地址弹窗 -->
    <div class="select-addr" v-show="isShowAddrPicker">
      <div class="cover" @click="isShowAddrPicker=0"></div>
      <div class="select-box">
        <div class="til">选择地址</div>
        <mt-picker ref="areaPicker" v-show="addrPickerLevel === 0" :slots="area" :visibleItemCount="5" @change="onAreaChange"></mt-picker>
        <mt-picker ref="streetPicker" v-show="addrPickerLevel === 1" :slots="street" :visibleItemCount="5" @change="onTownChange"></mt-picker>
        <div class="btn-box">
          <div class="cancel" @click="isShowAddrPicker=0">取消</div><div class="confirm" @click="confirmAddr">确定</div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// import {Picker, Switch} from 'mint-ui'
import {getConfigAddress, userAreaAdd, userAreaEdit} from "../../api/api"

export default {
  name: "AddMyAddr",
  data(){
    return{
      isShowAddrPicker: false,
      area_id: undefined,

      addrLevelMap: new Map([ [1, 'province'], [2, 'city'], [3, 'county'], [4, 'town'], [5, 'street'] ]),
      provinceMap: new Map(),
      cityMap: new Map(),
      countyMap: new Map(),
      townMap: new Map(),
      streetMap: new Map(),

      selectedArea_: undefined,
      selectedStreet_: undefined,
      selectedArea: undefined,
      selectedStreet: undefined,
      area: [
        {
          flex: .5,
          values: [],
          className: 'province',
          textAlign: 'center'
        },
        {
          flex: .5,
          values: [],
          className: 'city',
          textAlign: 'center'
        },
        {
          flex: .5,
          values: [],
          className: 'district',
          textAlign: 'center'
        }
      ],
      street: [{
        flex: .5,
        values: [],
        className: 'street',
        textAlign: 'center'
      }],
      addrPickerLevel: 0, // 0-area 1-street

      name: '',
      phone: '',
      province: '',
      city: '',
      county: '',
      town: '',
      addrDetail: '',
      isDefaultAddr: false,

    }
  },
  created() {
    let {area_id} = this.$route.query
    this.area_id = area_id
  },
  mounted() {
    if(this.area_id) this.$nextTick(()=>{this.initAddrInfo()})
  },
  methods:{

    // --- 地址选择 ---

    showAddrPicker(level = 0){

      if(level === 1 && this.selectedArea == undefined) {
        this.$uihelper.toast('请先选择所在地区')
        return
      }

      this.isShowAddrPicker = true
      this.addrPickerLevel = level
    },
    confirmAddr(){
      this.isShowAddrPicker = false
      if(this.addrPickerLevel === 0){
        this.selectedArea = this.selectedArea_
        this.selectedStreet = undefined
      }else{
        this.selectedStreet = this.selectedStreet_
      }
    },
    onAreaChange(picker, val){
      console.log('选择', val)

      let province = val[0], city = val[1], county = val[2]

      if(!province && !city && !county){
        this.network().getConfigAddress(0)
      }

      let getAddr = (level) => {
        let list = [ ['province', province], ['city', city], ['county', county] ]
        let area = (new Map(list)).get(level)
        if(area && this.selectedArea_[0] !== area){
          let areaData = this[level+'Map'].get(area)
          if(areaData) this.network().getConfigAddress(areaData.id)
        }
      }

      if(province && this.selectedArea_ && this.selectedArea_[0] !== province) { getAddr( 'province') } else
      if(city && this.selectedArea_ && this.selectedArea_[1] !== city) { getAddr('city') }  else
      if(county && this.selectedArea_ && this.selectedArea_[2] !== county) getAddr('county')

      this.selectedArea_ = [...val]
    },
    onTownChange(picker, val){

      this.selectedStreet_ = [...val]

    },

    // 初始化地址
    initAddrInfo(){
      let {area_id, username, phone, province, city, county, town, detail, is_default} = this.$route.query

      this.area_id = area_id
      this.name = username
      this.phone = phone

      this.province = province
      this.city = city
      this.county = county
      this.town = town

      this.addrDetail = detail
      this.isDefaultAddr = !!(+is_default)

      this.selectedArea = [province, city, county]
      this.selectedStreet = [town]


    },


    // --- 其它方法 ---

    getSaveInfo(){

      let {name, phone, selectedArea: area, selectedStreet: street} = this

      let province={}, city={}, county={}, town={}
      if(area){
        province = this.provinceMap.get(area[0]) || {}
        city = this.cityMap.get(area[1]) || {}
        county = this.countyMap.get(area[2]) || {}
      }
      if(street){
        town = this.townMap.get(street[0]) || {}
      }

      return {
        username: name,
        phone: phone,
        province_id: province.id,
        province: province.name,
        city_id: city.id,
        city: city.name,
        county_id: county.id,
        county: county.name,
        town_id: town.id,
        town: town.name,
        detail: this.addrDetail,
        is_default: + this.isDefaultAddr,
        code: town.code
      }

    },
    checkSaveData(){

      let data = this.getSaveInfo()

      let saveAble = true, message = '请填写完整信息'

      let mapArr = [
        ['username', '请输入收货人姓名'],
        ['phone', '请输入手机号码'],
        ['province_id', '请选择地址'],
        ['province', '请选择地址'],
        ['city_id', '请选择地址'],
        ['city', '请选择地址'],
        ['county_id', '请选择地址'],
        ['county', '请选择地址'],
        ['town_id', '请选择街道'],
        ['town', '请选择街道'],
        ['detail', '请输填写详细地址']
      ]

      let checkMap = new Map(mapArr)

      for (let i in data){
        if([undefined, null, ''].includes(data[i])){
          saveAble = false
          message = checkMap.get(i)
          if(message) return {saveAble, message}
        }
      }

      return {saveAble, message}

    },
    save(){

      // 检查字段
      let checkResult = this.checkSaveData()
      if(!checkResult.saveAble){
        this.$uihelper.toast(checkResult.message)
        return
      }

      if(this.area_id){
        this.network().userAreaEdit(Object.assign(this.getSaveInfo(), {area_id: this.area_id})) // 用户更新地址
      }else{
        this.network().userAreaAdd()  // 用户添加地址
      }
    },



// --- 网络请求 ---

    network(){
      return{

        // 获取地域信息
        getConfigAddress: async (parent_id)=>{
          let {data} = await getConfigAddress({parent_id})
          console.log('地域信息', data)

          let {code, message} = data

          if(code == 200){
            this.handle().getConfigAddress(data.data)
          }else {
            this.$uihelper.toast(message)
          }

        },

        // 添加地址
        userAreaAdd: async () => {

          let {data} = await userAreaAdd(this.getSaveInfo())

          let {code, message} = data

          if(code == 200){
            this.$uihelper.toast(message)
            this.$router.go(-1)         // 添加地址成功返回上一页
          }else{
            this.$uihelper.toast(message)
          }

        },

        // 更新地址
        userAreaEdit: async (param) => {
          console.log('更新地址参数', param)
          let {data} = await userAreaEdit(param)
          console.log('更新地址', data)

          let {code, message} = data
          if(code == 200){
            this.$uihelper.toast(message)
            this.$router.go(-1)
          }else{
            this.$uihelper.toast(message)
          }
        },

      }
    },
    handle(){
      return {
        getConfigAddress: (data) => {
          let {list} = data
          let picker = this.addrPickerLevel === 0 ? this.$refs.areaPicker : this.$refs.streetPicker

          let addrLevel = list[0].level
          let levelName = this.addrLevelMap.get(addrLevel)
          let mapName = levelName + 'Map'

          this[mapName] = new Map()

          let addrList = []
          for(let i in list){
            this[mapName].set(list[i].name, list[i])
            addrList.push(list[i].name)
          }

          if(picker){
            let slotIndex = addrLevel-1
            if(slotIndex < 3){
              if(this.addrPickerLevel === 0){
                picker.setSlotValues(slotIndex, addrList)
                picker.setSlotValue(slotIndex, this[levelName])
              }
            }else{
              this.addrPickerLevel === 1 && picker.setSlotValues(0, addrList)
              if(this.addrPickerLevel === 0) this.street[0].values = addrList
              this.$refs.streetPicker.setSlotValue(0, this[levelName])
            }
          }

        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "addMyAddr";
</style>
